import React, { useContext } from 'react';

import { trackEvent } from 'utils/metricsTracking';
import { EVENTS } from 'consts/metricsTrackingEvents';

import { ProductCardsContainer } from './ProductCards.style';
import { ProductCard, type ProductCardProps } from './components';
import { ModuleNameContext } from '../../../ModuleNameContext';

export const ProductCards = ({
  content,
  productCardCTAText,
}: {
  content: ProductCardProps[];
  productCardCTAText?: string;
}) => {
  const moduleName = useContext(ModuleNameContext);

  let hasScrolled = false;
  const handleScroll = () => {
    if (!hasScrolled) {
      hasScrolled = true;

      trackEvent(EVENTS.moduleInteraction, {
        module: moduleName,
      });
    }
  };

  return (
    <ProductCardsContainer onScroll={handleScroll}>
      {content.map((productCardContent) => (
        <ProductCard
          content={productCardContent}
          productCardCTAText={productCardCTAText}
          key={productCardContent.name}
        />
      ))}
    </ProductCardsContainer>
  );
};
